import { render } from "./FishGallery.vue?vue&type=template&id=1009af56"
import script from "./FishGallery.vue?vue&type=script&lang=js"
export * from "./FishGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__